<template>
  <div id="app">
    <router-view/>
    
    <FloatingWindow 
      v-if="shouldShowFloatingWindow"
      title="下载APP" 
      @action="handleFloatingAction"
    />
  </div>
</template>

<script>
import FloatingWindow from '@/components/common/FloatingWindow.vue'

export default {
  name: 'App',
  components: {
    FloatingWindow
  },
  computed: {
    shouldShowFloatingWindow() {
      // 在这些页面显示悬浮窗：首页、商城、分类、详情页、关于我们
      const showPages = ['HomePage', 'MallPage', 'CategoryList', 'AboutUs', 'ProductDetail', 'ProductCustomDetail'];
      return showPages.includes(this.$route.name);
    }
  },
  methods: {
    handleFloatingAction() {
      console.log('下载APP按钮被点击');
      // 在这里处理下载APP的逻辑
    }
  }
}
</script>

<style>
#app {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style> 